var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from 'react';
import { Admin, Resource } from 'react-admin';
import { Route } from 'react-router';
import merge from 'lodash/fp/merge';
import { ApiHubProvider, guessApihubUrl, guessApihubTenantName, } from './ApiHubContext';
import { authProvider } from './authentication';
import { dataProvider } from './dataProvider';
import { i18nProvider, defaultLocale } from './i18n';
import { LoginPage, NewPasswordPage, ResetPasswordPage, AccountSetupPage, SignUpPage, } from './authentication';
import { HomePageContent } from './homepage';
import { apis } from './apis';
import { applications } from './applications';
import { documents } from './documentation';
import { userProfiles } from './userProfiles';
import { ApiHubLayout } from './ApiHubLayout';
import { readApiHubPreference } from './preferences';
import { theme as defaultTheme } from './theme';
import { documentationReducer } from './documentation/Documentation/documentationReducer';
const defaultCustomRoutes = [];
export const ApiHubAdmin = (_a) => {
    var { 
    // ApiHub Settings
    url = guessApihubUrl(), tenantName = guessApihubTenantName(), originHubName, useSameOrigin = true, 
    // Custom Pages and Layout
    dashboard = HomePageContent, layout = ApiHubLayout, loginPage = LoginPage, resetPasswordPage = ResetPasswordPage, newPasswordPage = NewPasswordPage, accountSetupPage = AccountSetupPage, signUpPage = SignUpPage, 
    // React Admin Settings
    theme = defaultTheme, customReducers, customRoutes = defaultCustomRoutes, initialState, children } = _a, props = __rest(_a, ["url", "tenantName", "originHubName", "useSameOrigin", "dashboard", "layout", "loginPage", "resetPasswordPage", "newPasswordPage", "accountSetupPage", "signUpPage", "theme", "customReducers", "customRoutes", "initialState", "children"]);
    const defaultLocaleFromPreferences = readApiHubPreference('locale', defaultLocale);
    const defaultSidebarOpenFromPreferences = readApiHubPreference('sidebarOpen', true);
    const finalInitialState = merge({
        admin: {
            ui: {
                sidebarOpen: !!defaultSidebarOpenFromPreferences,
                viewVersion: 0,
            },
        },
    }, initialState);
    const resources = [
        // Resources which are needed for references but which will not have any UI
        React.createElement(Resource, { key: "apiEulas", name: "apiEulas" }),
        React.createElement(Resource, { key: "apiGroups", name: "apiGroups" }),
        React.createElement(Resource, { key: "assets", name: "assets" }),
        React.createElement(Resource, { key: "customFields", name: "customFields" }),
        React.createElement(Resource, { key: "documents", name: "documents" }),
        React.createElement(Resource, { key: "organizations", name: "organizations" }),
        React.createElement(Resource, { key: "specs", name: "specs" }),
        React.createElement(Resource, { key: "tags", name: "tags" }),
        React.createElement(Resource, { key: "userContexts", name: "userContexts" }),
    ];
    // If the user provided their own resources, they should override the defaults.
    if (Children.count(children) > 0) {
        Array.prototype.push.apply(resources, Children.toArray(children));
    }
    else {
        resources.push(React.createElement(Resource, Object.assign({ key: "apis", name: "apis" }, apis)), React.createElement(Resource, Object.assign({ key: "applications", name: "applications" }, applications)), React.createElement(Resource, Object.assign({ key: "userProfiles", name: "userProfiles" }, userProfiles)));
    }
    return (React.createElement(ApiHubProvider, { url: url, tenantName: tenantName, originHubName: originHubName },
        React.createElement(Admin, Object.assign({ authProvider: authProvider(url, tenantName, originHubName), dataProvider: dataProvider(url, tenantName, originHubName), i18nProvider: i18nProvider(defaultLocaleFromPreferences), theme: theme, layout: layout, loginPage: loginPage, dashboard: dashboard, customRoutes: [
                // React-Router loads only the first route that matches a path.
                // The only way to allow customizing the pre-defined routes
                // is to pass the customRoutes from the props before.
                ...customRoutes,
                // The Wiki Page displays a list of documents in a non standard way.
                React.createElement(Route, { path: "/howto", component: documents.list }),
                React.createElement(Route, { path: "/reset-password*", component: resetPasswordPage, noLayout: true }),
                React.createElement(Route, { path: "/new-password*", component: newPasswordPage, noLayout: true }),
                React.createElement(Route, { path: "/account-setup*", component: accountSetupPage, noLayout: true }),
                React.createElement(Route, { path: "/signup", component: signUpPage, noLayout: true }),
            ], customReducers: merge(documentationReducer, customReducers), initialState: finalInitialState }, props), resources)));
};
//# sourceMappingURL=ApiHubAdmin.js.map